import TabsPanels from '@/components/tabs/TabsPanels';

import { ISSUE_DETAIL_PANELS, ISSUE_DETAIL_PANELS_ROUTES } from '@/constants/app/issues/tabs';
import IssueDetailsTab from './IssueDetailsTab';
import IssueEventsTab from './IssueEventsTab';

import type { Issue } from '@/types';

interface IssueTabsPanelsProps {
  issue: Issue;
  hide: () => void;
}

const IssueTabsPanels = ({ issue, hide }: IssueTabsPanelsProps) => (
  <TabsPanels
    name="issue-detail"
    panels={ISSUE_DETAIL_PANELS}
    routes={ISSUE_DETAIL_PANELS_ROUTES}
    components={[
      () => <IssueDetailsTab issue={issue} hide={hide} />,
      () => <IssueEventsTab issue={issue} />,
    ]}
  />
);

export default IssueTabsPanels;
